var Enumeration = require('utility-js-enumeration').default;

module.exports = Enumeration('TimeWindowEnum', {
  DAY: {
    moment: 'day',
    heading: function () {
      return '';
    }
  },
  WEEK: {
    moment: 'week',
    heading: function () {
      return '';
    }
  },
  MONTH: {
    moment: 'month',
    heading: function () {
      return '';
    }
  },
  QUARTER: {
    moment: 'quarter',
    heading: function () {
      return '';
    }
  },
  YEAR: {
    moment: 'year',
    heading: function () {
      return '';
    }
  }
});



// WEBPACK FOOTER //
// time_window_enum.js